import { defineMessage } from 'react-intl';

/**
 * Intl messages for the connection-first social export manage screen.
 */
export const connectionsManageMessages = {
  connectedAccounts: defineMessage({
    id: 'socialExport.connections.connectedAccounts',
    defaultMessage: 'Cuentas conectadas',
  }),
  connect: defineMessage({
    id: 'socialExport.connect',
    defaultMessage: 'Conectar',
  }),
  linkedStationsCount: defineMessage({
    id: 'socialExport.connections.linkedStationsCount',
    defaultMessage:
      '{count, plural, =0 {Sin emisoras vinculadas} one {# emisora vinculada} other {# emisoras vinculadas}}',
  }),
  stationsPublishingWithAccount: defineMessage({
    id: 'socialExport.connections.stationsPublishingWithAccount',
    defaultMessage: 'Emisoras vinculadas',
  }),
  noLinkedStations: defineMessage({
    id: 'socialExport.connections.noLinkedStations',
    defaultMessage: 'No hay emisoras vinculadas aún',
  }),
  connectedByPrefix: defineMessage({
    id: 'socialExport.connections.connectedByPrefix',
    defaultMessage: 'Conectado por',
  }),
  selectStations: defineMessage({
    id: 'socialExport.connections.selectStations',
    defaultMessage: 'Emisoras',
  }),
  selectStationsPlaceholder: defineMessage({
    id: 'socialExport.connections.selectStationsPlaceholder',
    defaultMessage: 'Seleccione una o más emisoras',
  }),
  selectStationsHelper: defineMessage({
    id: 'socialExport.connections.selectStationsHelper',
    defaultMessage: 'Solo estas emisoras van a poder publicar con esta cuenta.',
  }),
  accountIdentification: defineMessage({
    id: 'socialExport.connections.accountIdentification',
    defaultMessage: 'Identificación de la cuenta',
  }),
  customName: defineMessage({
    id: 'socialExport.connections.customName',
    defaultMessage: 'Nombre personalizado',
  }),
  customNameHelper: defineMessage({
    id: 'socialExport.connections.customNameHelper',
    defaultMessage: 'Opcional. Útil si hay más de una conexión al mismo perfil.',
  }),

  configure: defineMessage({
    id: 'socialExport.manage.configure',
    defaultMessage: 'Configurar',
  }),
  disconnect: defineMessage({
    id: 'socialExport.manage.disconnect',
    defaultMessage: 'Desconectar',
  }),
  emptyConnections: defineMessage({
    id: 'socialExport.connections.empty',
    defaultMessage: 'No hay cuentas conectadas',
  }),
  emptyConnectionsHelp: defineMessage({
    id: 'socialExport.connections.emptyHelp',
    defaultMessage: 'Conectá una cuenta para comenzar a publicar en esta plataforma.',
  }),
  connectionDetail: defineMessage({
    id: 'socialExport.connections.connectionDetail',
    defaultMessage: 'Detalle',
  }),
  selectConnection: defineMessage({
    id: 'socialExport.connections.selectConnection',
    defaultMessage: 'Seleccioná una cuenta para ver el detalle',
  }),
  disconnectConfirmTitle: defineMessage({
    id: 'admin.integrations.warningTitle',
    defaultMessage: 'Atención',
  }),
  disconnectConfirmDescription: defineMessage({
    id: 'socialExport.connections.disconnectConfirmDescription',
    defaultMessage: 'Estás a punto de desconectar esta integración. ¿Estás seguro?',
  }),
  disconnectWithStationsWarning: defineMessage({
    id: 'socialExport.connections.disconnectWithStationsWarning',
    defaultMessage:
      'Esta cuenta está vinculada a {count, plural, one {# emisora} other {# emisoras}}. Al desconectar, esas emisoras dejarán de poder publicar con ella. ¿Estás seguro?',
  }),
  accept: defineMessage({
    id: 'admin.integrations.accept',
    defaultMessage: 'Aceptar',
  }),
  cancel: defineMessage({
    id: 'admin.integrations.cancel',
    defaultMessage: 'Cancelar',
  }),
  connectionSuccessLinkStations: defineMessage({
    id: 'socialExport.connectionSuccess.linkStations',
    defaultMessage: 'Vinculá emisoras a esta cuenta y configurá los valores por defecto.',
  }),
  settingsTitle: defineMessage({
    id: 'socialExport.connections.settingsTitle',
    defaultMessage: 'Configurar {name}',
  }),
  selectConnectionForPublish: defineMessage({
    id: 'socialExport.connections.selectForPublish',
    defaultMessage: 'Cuenta de publicación',
  }),
  history: defineMessage({
    id: 'socialExport.history',
    defaultMessage: 'Historial',
  }),
};
